import { render, staticRenderFns } from "./AdminNavigationDrawer.vue?vue&type=template&id=4a5f422a&scoped=true"
import script from "./AdminNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./AdminNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./AdminNavigationDrawer.vue?vue&type=style&index=0&id=4a5f422a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f422a",
  null
  
)

export default component.exports